import { render, staticRenderFns } from "./InfoboxRequests.vue?vue&type=template&id=6da364d8&scoped=true&"
import script from "./InfoboxRequests.vue?vue&type=script&lang=js&"
export * from "./InfoboxRequests.vue?vue&type=script&lang=js&"
import style0 from "./InfoboxRequests.vue?vue&type=style&index=0&id=6da364d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da364d8",
  null
  
)

export default component.exports